import { render, staticRenderFns } from "./memo-popup.vue?vue&type=template&id=e42b87ca&scoped=true"
import script from "./memo-popup.vue?vue&type=script&lang=js"
export * from "./memo-popup.vue?vue&type=script&lang=js"
import style0 from "./memo-popup.vue?vue&type=style&index=0&id=e42b87ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42b87ca",
  null
  
)

export default component.exports